// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-breadcrumb[data-v-3c8a5986]{padding:20px 5px;background:transparent}.h-view[data-v-3c8a5986]{height:calc(100vh - 115px)}.max-avue-main[data-v-3c8a5986]{width:100%!important;left:0}", ""]);
// Exports
module.exports = exports;
